export const ALLMOVIES = "ALLMOVIES";
export const SEARCHMOVIE = "SEARCHMOVIE";
export const GETMOVIEDETAILS = "GETMOVIEDETAILS";
//  constants
export const MOVIEAPIKEY = "9bde724434cd2ef83bccc262c14d0248&query";
export const BASEURL = "https://api.themoviedb.org/3";
export const MOVIEAPI = `${BASEURL}/movie/popular?api_key=${MOVIEAPIKEY}&language=ar&page=1`;
export const SEARCHAPI = `${BASEURL}/search/movie?api_key=${MOVIEAPIKEY}&language=ar&page=1&query=`;
export const PAGEURL = `${BASEURL}/movie/popular?api_key=${MOVIEAPIKEY}&language=ar&page=`;
export const MOVIEDETAILS = `${BASEURL}/movie/`;
